// ** Reactstrap Imports
import classNames from 'classnames';
import { Button } from 'reactstrap';

const TodoSidebar = (props) => {
  // ** Props
  const { handleQuestionSidebar, setSelectedQuestion } = props;

  // ** Functions To Handle Add Questio Click
  const handleAddClick = () => {
    setSelectedQuestion({});
    handleQuestionSidebar();
  };

  // return (
  //   <Button color="primary" onClick={handleAddClick}>
  //     Agregar Pregunta
  //   </Button>
  // );

  return (
    <div className={classNames('sidebar-left')}>
      <div className="sidebar">
        <div className="sidebar-content todo-sidebar">
          <div className="todo-app-menu">
            <div className="add-task">
              <Button color="primary" onClick={handleAddClick}>
                Agregar Pregunta
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TodoSidebar;
